const translations = {
  cancel: 'Cancel',
  save: 'Save',
  next: 'Next',
  back: 'Back',
  undo: 'Undo',
  search: 'Search',
  user: 'User',
  place: 'Place',
  images: 'Images',
  files: 'Files',
  notApplicable: 'N/A',
  removed: 'Removed',
  disabled: 'Disabled',
  enabled: 'Enabled',
  addNewOption: 'Add new option',
  selectEmoji: 'Select emoji',
  optional: 'optional',
  'emoji.smileysPeople': 'Smileys & People',
  'emoji.animalsNature': 'Animals & Nature',
  'emoji.foodDrink': 'Food & Drink',
  'emoji.travelPlaces': 'Travel & Places',
  'emoji.activities': 'Activities',
  'emoji.objects': 'Objects',
  'emoji.symbols': 'Symbols',
  complement: 'Complement',
  complementOptional: 'Complement (optional)',
  hour: 'Hour',
  minute: 'Min.',
  errorLoadingGoogleMaps: 'Error loading Google Maps',
  'pdf.autoPageBreak': 'Auto page break adjustment',
  'pdf.baseFontSize': 'Base font size',
  'pdf.enableColors': 'Enable colors',
  'pdf.showImages': 'Show images',
  'pdf.showSignature': 'Show signature',
  'pdf.imageHeight': 'Image height',
  'pdf.itemsPerLine': 'Images and files per line',
  'pdf.options.realSize': 'Actual size',
  'pdf.options.size.verySmall': 'Very small',
  'pdf.options.size.small': 'Small',
  'pdf.options.size.standard': 'Standard',
  'pdf.options.size.medium': 'Medium',
  'pdf.options.size.large': 'Large',
  'pdf.options.size.veryLarge': 'Very large',
  'pdf.options.size.giant': 'Giant',
  'pdf.options.sizeWithPx': '{{size}} ({{px}}px)',
  'pdf.options.sizeWithNumber': '{{size}} ({{value}})',
  'pdf.options.perLine': '{{count}} per line',
  'pdf.download': 'Download {{extension}}',
  'pdf.imagesCount': '{{count}} image',
  'pdf.imagesCount_plural': '{{count}} images',
  'pdf.filesCount': '{{count}} file',
  'pdf.filesCount_plural': '{{count}} files',
  'pdf.itemCount': '{{count}} item',
  'pdf.itemCount_plural': '{{count}} items',
  'pdf.notes': 'Notes',
  'pdf.photos': 'Photos',
  'pdf.active': 'Active',
  'pdf.inactive': 'Inactive',
  'pdf.stock.item': 'Item',
  'pdf.stock.amount': 'Quantity',
  'pdf.stock.operation': 'Operation',
  'pdf.stock.user': 'User',
  'pdf.stock.place': 'Place',
  'filter.enabledDisabled': 'Enabled/Disabled',
  'filter.enabled': 'Enabled',
  'filter.disabled': 'Disabled',
  'filter.removed': 'Removed',
  'messages.mobileAccuracy': 'For greater accuracy, please respond via the app.',
  clearAndInsertNewSignature: 'Clear and insert new signature',
  clear: 'Clear',
  insertSignature: 'Insert signature',
  document: 'Document',
  includeSignatureInRectangle: 'Include your signature inside the rectangle',
  nameRequired: 'Name (required)',
  addSignature: 'Add signature',
  signaturePrefilledFromProfile: 'Signature pre-filled from your profile. You can change it if needed.',
  updateLocation: 'Update Location',
  saveLocation: 'Save Location',
  latitude: 'Latitude',
  longitude: 'Longitude',
  permissionDeniedInBrowser: 'Permission denied in browser',
  'processesMessage.backToPreviousVersion': 'Back to previous version',
  'processesMessage.activateNewVersion': 'Activate new version',
  'processesMessage.newFeatureActivated': '**New feature activated!**',
  'processesMessage.discoverNewFeature': '**Discover the new feature!**',
  'processesMessage.enjoyNewFeature': 'Enjoy the new feature to manage activities by process.',
  'processesMessage.viewAndManageByProcess': 'View and manage activities by process.',
  generalRegistrations: 'General registrations',
  pendingTypes: 'Pending types',
  approvalReasons: 'Approval reasons',
  disapprovalReasons: 'Disapproval reasons',
  unproductiveReasons: 'Unproductive reasons',
  cancellationReasons: 'Cancellation reasons',
  pauseReasons: 'Pause reasons',
  closingReasons: 'Closing reasons',
  userGroups: 'User groups',
  assetTypes: 'Asset types',
  checklistCategories: 'Checklist categories',
  levelsOf: 'Levels of {{name}}'
}

export default translations
